"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// MARK Mobx
var mobx_1 = require("mobx");
var _1 = require(".");
var ArrayIdListShelf = /** @class */ (function () {
    function ArrayIdListShelf(getItems) {
        var _this = this;
        /**
         * This relies on the API convention to use
         * 20 items per page fetch. The info Should come from
         * the api.
         */
        this.itemPerPage = 20;
        this.loader = new _1.LoaderShelf();
        this.initialLoaded = new _1.InitialLoaderShelf();
        /**
         * The fetch call used to manipulate and get the data
         * using the abstract method implemented by the child class
         */
        this.fetchData = function (newPage) {
            if (newPage === void 0) { newPage = 0; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var hasToReplace, possibleItems_1, e_1;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.loader.isLoading) {
                                return [2 /*return*/];
                            }
                            hasToReplace = false;
                            if (!newPage || newPage < 0) {
                                hasToReplace = true;
                                this._hasNextPage = true;
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            this.loader.start();
                            return [4 /*yield*/, this._getItems(newPage)];
                        case 2:
                            possibleItems_1 = _a.sent();
                            if (possibleItems_1.length > 0) {
                                mobx_1.runInAction(function () {
                                    _this._page = newPage;
                                    _this._hasNextPage = (possibleItems_1.length === _this.itemPerPage);
                                });
                                this.appendItems(possibleItems_1, hasToReplace);
                            }
                            else {
                                this.appendItems(possibleItems_1, true);
                                this._hasNextPage = false;
                            }
                            return [3 /*break*/, 5];
                        case 3:
                            e_1 = _a.sent();
                            mobx_1.runInAction(function () {
                                _this.fetchError = e_1;
                            });
                            return [3 /*break*/, 5];
                        case 4:
                            this.loader.end();
                            this.initialLoaded.done();
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        this.applyFilter = function (filter) {
            _this.appendItems(_this.listItems.filter(filter), true);
        };
        this.appendItems = function (newItems, replace) {
            if (replace === void 0) { replace = false; }
            if (replace) {
                _this._items = newItems;
            }
            else {
                _this._items = tslib_1.__spreadArray(tslib_1.__spreadArray([], _this._items), newItems);
            }
        };
        this.replaceItem = function (itemId, newValue) {
            if (_this._items.length <= 0) {
                return;
            }
            var foundIndex = 0;
            var foundItem = _this._items.find(function (item, index) {
                if (item.id[0] === itemId) {
                    foundIndex = index;
                    return true;
                }
                return false;
            });
            if (foundItem) {
                var leftList = _this._items.filter(function (_, i) { return i < foundIndex; });
                var rightList = _this._items.filter(function (_, i) { return i > foundIndex; });
                _this._items = tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray([], leftList), [newValue]), rightList);
            }
        };
        this.nextPage = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._hasNextPage) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchData(this._page + 1)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        this.refreshItems = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.clear = function () {
            _this.fetchError = null;
            _this._items = [];
            _this._page = 0;
        };
        this._page = 0;
        this._hasNextPage = true;
        this.fetchError = null;
        this._items = [];
        this._getItems = getItems;
        mobx_1.makeAutoObservable(this);
        this.fetchData();
    }
    Object.defineProperty(ArrayIdListShelf.prototype, "listItems", {
        /**
         * Implement this function as a data call provider to the list data fetch.
         *
         * @param newPageNumber number of the page of a paginated data fetch.
         * @returns Promise<ListItemObject[]> A promise of objects used to render the list. the number of
         * Objects must be equal to 20 for each page, this is currently a convention for
         * the api used, but this must change in order to make the class more reusable.
         */
        /**
         * @returns all items of the list
         */
        get: function () {
            return this._items.slice();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArrayIdListShelf.prototype, "isLoading", {
        /**
         * @returns If the list is fetching data
         */
        get: function () {
            return this.loader.isLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ArrayIdListShelf.prototype, "listHasNextPage", {
        get: function () {
            return this._hasNextPage;
        },
        enumerable: false,
        configurable: true
    });
    return ArrayIdListShelf;
}());
exports.default = ArrayIdListShelf;
